Promise.all([import('scripts/marmalade/functions/add-breakpoint')]).then(_ref => {
  let [functionAddBreakpoint] = _ref;
  // Define the components
  const addBreakpoint = functionAddBreakpoint.default;

  // Find the tabbed navigation
  const nav = document.querySelector('.js-tabbed-navigation');
  // Find the navigation list
  const list = nav.querySelector('.js-tabbed-navigation__list');

  // Add a breakpoint class when the list is wider than the navigation
  addBreakpoint(nav, () => list.clientWidth > nav.clientWidth);
}).catch(error => {
  console.error('There was a problem loading the script:', error);
});